<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Fusion</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @if (data.sourceFolders.length === 1) {
                <p class="text">ATTENTION! Vous êtes sur le point de fusionner le dossier '{{ data.sourceFolders[0].name }}' dans le dossier '{{ data.targetFolder.name }}'.</p>
            } @else if (data.sourceFolders.length > 1) {
                <p class="text">ATTENTION! Vous êtes sur le point de fusionner {{ data.sourceFolders.length }} dossiers dans le dossier '{{ data.targetFolder.name }}'.</p>
                <ul class="foldersList">
                    @for (folder of data.sourceFolders; track folder.id) {
                        <li>
                            {{ folder.name }}
                        </li>
                    }
                </ul>
            }

            <br />
            <p class="question">Confirmez-vous la fusion ?</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="false">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="true">Valider</button>
    </mat-card-actions>
</mat-card>
